import { createFileRoute, redirect } from '@tanstack/react-router'
import { Subscription } from '../../features/subscription/Subscription.tsx'

export const Route = createFileRoute('/_app/subscription')({
	component: Subscription,
	beforeLoad: ({ context: { isAdmin } }) => {
		if (!isAdmin) {
			throw redirect({ to: '/' })
		}
	},
})
